









import { Component, Vue } from 'vue-property-decorator'
import store from '../store'
import axios from 'axios'
import card from '@/components/card.vue'
import { getNotifications } from '@/api/system'

@Component({
  name: 'Notification',
  components: { card }
})
export default class extends Vue {
  created() {
    this.loadNotifications()
  }
  get orderNotifications() {
    return this.$store.state.notifications.filter(not => {
      return not.dbTypeId == 1 && not.active
    })
  }
  get stockNotifications() {
    return this.$store.state.notifications.filter(not => {
      return not.dbTypeId == 2 && not.active
    })
  }
  get mailNotifications() {
    return this.$store.state.notifications.filter(not => {
      return not.dbTypeId == 3 && not.active
    })
  }
  async loadNotifications() {
    this.$store.dispatch('loadNotifications')
  }
}
